/**
 * 塾管理(academy)画面のルーティング設定
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import RootView from '../views/academy/RootView.vue'
import AcademyLogin from '../views/academy/AcademyLogin.vue'
import AcademyStudents from '../views/academy/AcademyStudents.vue'
import AcademyStudentsGeneralLearningProgress from '../views/academy/AcademyStudentsGeneralLearningProgress.vue'
import AcademyStudentsSystemChartProgress from '../views/academy/AcademyStudentsSystemChartProgress.vue'
import StudentStudyCategoryProgress from '../views/academy/StudentStudyCategoryProgress.vue'
import StudentLearningMapProgress from '../views/academy/StudentLearningMapProgress.vue'
import AcademyBranches from '../views/academy/AcademyBranches.vue'
import AcademyTeachers from '../views/academy/AcademyTeachers.vue'
import BranchLearningProgress from '../views/academy/BranchLearningProgress.vue'
import CourseLearningProgress from '../views/academy/CourseLearningProgress.vue'
import ClassLearningProgress from '../views/academy/ClassLearningProgress.vue'
import AcademyNoticeList from '../views/academy/AcademyNoticeList.vue'
import AcademyNoticeRegist from '../views/academy/AcademyNoticeRegist.vue'
import AcademyNoticeDetail from '../views/academy/AcademyNoticeDetail.vue'
import AcademyNoticeEdit from '../views/academy/AcademyNoticeEdit.vue'
import AcademyCurriculumUnits from '../views/academy/proofread/AcademyCurriculumUnits.vue'
import AcademyProblems from '../views/academy/proofread/AcademyProblems.vue'
import AcademyProblemInput from '../views/academy/proofread/AcademyProblemInput.vue'
import AcademyLearningMapUnits from '../views/academy/proofread/AcademyLearningMapUnits.vue'
import AcademyLearningMapProblems from '../views/academy/proofread/AcademyLearningMapProblems.vue'
import AcademyLearningMapProblemInput from '../views/academy/proofread/AcademyLearningMapProblemInput.vue'

/**
 * 塾管理者用ページ群
 */
const academyRoutes: Array<RouteConfig> = [
  // ルートアクセス時のリダイレクト処理
  {
    path: '/academy',
    name: 'AcademyRoot',
    component: RootView,
  },
  // ログイン
  {
    path: '/academy/login',
    name: 'AcademyLogin',
    component: AcademyLogin,
  },
  // 生徒管理画面
  {
    path: '/academy/students',
    name: 'AcademyStudents',
    component: AcademyStudents,
  },
  // 生徒の通常学習進捗一覧確認
  {
    path: '/academy/students/progress/general',
    name: 'AcademyStudentsGeneralLearningProgress',
    component: AcademyStudentsGeneralLearningProgress,
  },
  // 生徒の知識MAP系統図進捗一覧確認
  {
    path: '/academy/students/progress/map',
    name: 'AcademyStudentsSystemChartProgress',
    component: AcademyStudentsSystemChartProgress,
  },
  // 生徒毎進捗画面
  {
    path: '/academy/students/:userId/progress',
    name: 'AcademyStudentProgress',
    component: StudentStudyCategoryProgress,
  },
  // 生徒別学習進捗(知識マップ)
  {
    path: '/academy/students/:userId/map',
    name: 'AcademyStudentMap',
    component: StudentLearningMapProgress,
  },
  // 教室一覧
  {
    path: '/academy/branches',
    name: 'AcademyBranches',
    component: AcademyBranches,
  },
  // 先生一覧
  {
    path: '/academy/teachers',
    name: 'AcademyTeachers',
    component: AcademyTeachers,
  },
  // 通常学習進捗比較(教室)
  {
    path: '/academy/progress/branch',
    name: 'AcademyProgressBranch',
    component: BranchLearningProgress,
  },
  // 通常学習進捗比較(コース)
  {
    path: '/academy/progress/course',
    name: 'AcademyProgressCourse',
    component: CourseLearningProgress,
  },
  // 通常学習進捗比較(クラス)
  {
    path: '/academy/progress/class',
    name: 'AcademyProgressClass',
    component: ClassLearningProgress,
  },
  // お知らせ一覧
  {
    path: '/academy/notice',
    name: 'AcademyNoticeList',
    component: AcademyNoticeList,
  },
  // お知らせ登録(URLの関係上、必ず詳細より上に設定する)
  {
    path: '/academy/notice/regist',
    name: 'AcademyNoticeRegist',
    component: AcademyNoticeRegist,
  },
  // お知らせ詳細
  {
    path: '/academy/notice/:id',
    name: 'AcademyNoticeDetail',
    component: AcademyNoticeDetail,
  },
  // お知らせ編集
  {
    path: '/academy/notice/:id/edit',
    name: 'AcademyNoticeEdit',
    component: AcademyNoticeEdit,
  },
  // 校正画面-単元一覧画面
  {
    path: '/academy/proofread',
    name: 'AcademyProofread',
    component: AcademyCurriculumUnits,
  },
  // 校正画面-解答入力画面
  {
    path: '/academy/proofread/:curriculumUnitId/:problemId/',
    name: 'AcademyProofreadProblemInput',
    component: AcademyProblemInput,
  },
  // 校正画面-問題一覧画面
  {
    path: '/academy/proofread/:curriculumUnitId',
    name: 'AcademyProofreadProblems',
    component: AcademyProblems,
  },
  // 校正画面-単元一覧画面(知識マップ)
  {
    path: '/academy/map',
    name: 'AcademyMap',
    component: AcademyLearningMapUnits,
  },
  // 校正画面-解答入力画面(知識マップ)
  {
    path: '/academy/map/:curriculumUnitId/:problemId',
    name: 'AcademyMapProblemInput',
    component: AcademyLearningMapProblemInput,
  },
  // 校正画面-問題一覧画面(知識マップ)
  {
    path: '/academy/map/:curriculumUnitId',
    name: 'AcademyMapProblems',
    component: AcademyLearningMapProblems,
  },
]

export default academyRoutes
